<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="flex flex-col">
        <div class="flex flex-col md:flex-row md:items-center gap-2 md:gap-4 justify-start m-2">
          <div class="action-buttons">
            <button
              mat-raised-button
              class="btn btn-danger flex gap-2"
              (click)="goBack()"
            >
              <mat-icon>arrow_back</mat-icon> Back
            </button>
          </div>
          <div class="flex flex-row flex-nowrap items-center gap-2 md:gap-4 overflow-x-auto">
            @for (categorySegment of generalCategorySegments; track
            categorySegment) {
            <button
              mat-raised-button
              [disabled]="!!this.productId()"
              type="button"
              class="btn !min-w-0 !px-2 !text-xs md:!px-4 md:!text-sm whitespace-nowrap"
              (click)="onCategoryDetermined(categorySegment.id)"
              [ngClass]="
                selectedCategorySegment() === categorySegment.id
                  ? 'btn-primary'
                  : 'btn-light'
              "
            >
              {{ categorySegment.label }}
            </button>
            }
          </div>
        </div>
        <!-- Title left, score right: the score belongs to the whole product, not
             to any one field, so it sits above the form rather than inside it. -->
        <div class="flex items-center justify-between gap-4">
          <h4 class="m-0">{{formTitle()}}</h4>
          @if (productScore() !== null) {
            <span class="product-score" title="Vendor, orders, videos, images, customers and description, weighted">
              Score: {{ productScore() }}
            </span>
          }
        </div>

        <!-- Read-only while saving: the form is rebuilt from the server once the
             save lands, so anything typed in between would be silently lost. -->
        <div
          class="flex flex-col gap-4 justify-center"
          [class.form-saving]="saving()"
          [attr.inert]="saving() ? '' : null"
          [attr.aria-busy]="saving()"
        >
          @if(productId() > -1) {
          <fh-product-input
            [productId]="productId()"
            [initialSelectedCategory]="selectedCategorySegment()"
            [isCategoryEditable]="isCategoryEditable()"
            (formIsValid)="productInput.valid.set($event)"
            (formChanged)="productInput.data.set($event)"
            (productCategoryId)="onCategoryDetermined($event)"
            (productScore)="productScore.set($event)"
          >
          </fh-product-input>
          }
        </div>

        <div class="flex flex-col gap-4 justify-center">
          @if (errors().length > 0) {
            <div class="alert alert-danger alert-dismissible fade show" role="alert">
              <h5>Please fix the following errors:</h5>
              <ul class="mb-0">
                @for (error of errors(); track error.path) {
                  <li>
                    <strong>{{ error.path }}:</strong> {{ error.message }}
                  </li>
                }
              </ul>
            </div>
          }

          @if (success()) {
            <div class="alert alert-success alert-dismissible fade show" role="alert">
              {{ success() }}
            </div>
          }

          <button
            mat-raised-button
            type="button"
            (click)="saveProduct()"
            [disabled]="!productInput.valid() || saving()"
            class="btn btn-danger pull-right mt-20"
          >
            {{ saving() ? "Saving..." : "Save" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
